var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-row',[_c('v-col',{attrs:{"cols":"12","sm":"7"}},[_c('material-product-details-card-body-table')],1),_c('v-col',{attrs:{"cols":"12","sm":"5"}},[_c('material-product-details-card-body-buttons')],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }